import { default as Form } from "./Form"
import { default as Profile } from "./Profile"

const Student = {
  Form,
  Profile,
}

export default Student
